module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "header-area single-page"
  }, [_c('div', {
    staticClass: "header-top"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-lg-10"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main-menu main-menu-light"
  }, [_c('ul', _vm._l((_vm.menuList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        mainmenuli: !(item.children.length > 0)
      }
    }, [_c('a', {
      staticStyle: {
        "font-size": "20px"
      },
      style: (_vm.getStyle(index)),
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.routerlinkClick(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.children.length > 0) ? _c('ul', {
      staticClass: "sub-menu"
    }, _vm._l((item.children), function(childrenItem, index) {
      return _c('li', {
        key: index,
        staticClass: "mainmenuli"
      }, [_c('a', {
        staticStyle: {
          "font-size": "18px",
          "font-weight": "normal"
        },
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            return _vm.routerlinkClick(childrenItem)
          }
        }
      }, [_vm._v(_vm._s(childrenItem.name))])])
    }), 0) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "conent_box"
  }, [_c('router-view', {
    attrs: {
      "list": _vm.list,
      "menuList": _vm.menuList
    }
  })], 1), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "logo-area"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px",
      "height": "auto"
    },
    attrs: {
      "src": "static/assets/images/kunyu_logo.png"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-navbar"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer-area section-padding"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-3 col-lg-3"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 zuoyou"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("售前咨询热线:")]), _vm._v(" "), _c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("+86-21-67631999")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-5 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 lianix"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "mb-2"
  }, [_c('span', [_vm._v("上海坤瑀智能科技有限公司")])]), _vm._v(" "), _c('li', {
    staticClass: "mb-2"
  }, [_c('span', [_vm._v("地址：上海：崇明区兴奔路66号")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("            北京：丰台区马家堡西路15号1区21层")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("            天津：西青经济技术开发区兴华三支路5号E1座")])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("电话：+86-21-67631999")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-2"
  }, [_c('div', {
    staticClass: "single-widge-home chengxu"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("公众号")]), _vm._v(" "), _c('div', {
    staticClass: "feed",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "static/assets/images/kunyu_qrcode.png",
      "alt": "feed"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-2"
  }, [_c('div', {
    staticClass: "single-widge-home chengxu"
  }, [_c('h3', {
    staticClass: "mb-4"
  }, [_vm._v("移动端")]), _vm._v(" "), _c('div', {
    staticClass: "feed",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('ul', [_c('li', [_c('img', {
    attrs: {
      "src": "static/assets/images/kunyu_m_qrcode.png",
      "alt": "feed"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-6",
    staticStyle: {
      "text-align": "center",
      "font-size": "1.5vh"
    }
  }, [_c('span', [_vm._v("Copyright ©上海坤瑀智能科技有限公司")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07264466"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 285
// module chunks = 1